module.exports = __webpack_public_path__ + "static/media/becomeAHostGreen.acfb7a51.svg";